import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { canManageKiosk } from "../../utils/userUtils";

const KioskRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return canManageKiosk(user) ? children : <Navigate to="/" replace />;
};

export default KioskRoute;
